import React from 'react';
import styled from '@emotion/styled';
import { CheckWithCircleIcon } from '@seedlang/icons';
import { Theme } from '@seedlang/constants';
import { AppUI } from '@seedlang/state';
import Text from 'components/text';

const Option = styled.div`
  background: ${props => props.selected ? 'whitesmoke' : '#FFF'};
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid whitesmoke;
  cursor: pointer;
  .check-with-circle-icon {
    margin-right: 10px;
    svg {
      fill: ${props => props.selected ? Theme.green : '#CCC'};
    }
  }
  &:hover {
    background: whitesmoke;
  }
`;

const RadioCircle = styled.div`
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 50%;
  border: 2px solid ${props => props.selected ? (props.accentColor || '#CCC') : '#CCC'};
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RadioDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.accentColor || '#CCC'};
`;

function ReasonList({ options, selectedOption, selectedOptions = [], multipleChoice, onSelect }) {

  function isSelected(item) {
    if (multipleChoice) {
      return selectedOptions.some(s => (item.slug && s.slug === item.slug) || (item.id && s.id === item.id));
    }
    return (item.slug && selectedOption?.slug === item.slug) || (item.id && selectedOption?.id === item.id);
  }

  return (
    <div>
      {options.map(item => (
        <Option
          key={item.slug || item.id}
          onClick={() => onSelect(item)}
          selected={isSelected(item)}
        >
          {multipleChoice ? (
            <CheckWithCircleIcon />
          ) : (
            <RadioCircle selected={isSelected(item)} accentColor={AppUI.site.accentColor}>
              {isSelected(item) && <RadioDot accentColor={AppUI.site.accentColor} />}
            </RadioCircle>
          )}
          <Text>
            {item.text || item.option}
          </Text>
        </Option>
      ))}
    </div>
  );
}

export default ReasonList;
